exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".attachment-label[_v-4e0bf22a]{line-height:40px}.delivery-label[_v-4e0bf22a]{line-height:38px}.form-label[_v-4e0bf22a]{color:rgba(0,0,0,.26);font-size:16px!important}.textfield-padding-fix[_v-4e0bf22a]{margin-top:-20px}.mdl-checkbox[_v-4e0bf22a]{margin-left:10px}.mdl-cell .card-page-container[_v-4e0bf22a]{width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-4e0bf22a&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/pages/NewDelayed.vue
// module id = 307
// module chunks = 0